import { connect } from 'react-redux'

import {
  updateAirlineFiltersUI,
  updateAirlineFiltersReq,
  listingsFilterCall
} from '../../actions'

import { SponsoredFilter } from './SponsoredFilter'

const mapStateToAirlineProps = state => ({
  airlines: state.airlinesFilter || [],
  activeTabId: state.activeTabId,
  pclnBootstrapData: state.pclnBootstrapData
})

const mapDispatchToAirlineProps = {
  updateAirlineFiltersUI,
  updateAirlineFiltersReq,
  listingsFilterCall
}

const SponsoredFilterContainer = connect(
  mapStateToAirlineProps,
  mapDispatchToAirlineProps
)(SponsoredFilter)

export { SponsoredFilterContainer }
